const enabled = process.env.REACT_APP_ERROR_REPORTS_ENABLED === 'true';
const seen = new Set<string>();
let sent = 0;
let resetAt = Date.now();
let inFlight = false;
const scrub = (value: string, limit: number) => value
  .replace(/(?:https?:\/\/|\/)[^\s)]+/g, '[location omitted]')
  .replace(/-----BEGIN [\w ]*PRIVATE KEY-----[\s\S]*?(?:-----END [\w ]*PRIVATE KEY-----|$)/g, '[key omitted]')
  .replace(/\beyJ[\w-]+\.[\w-]+\.[\w-]+\b/g, '[token omitted]')
  .replace(/(?:Bearer\s+|xox[baprs]-)[^\s]+/gi, '[token omitted]')
  .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[email omitted]')
  .replace(/(password|token|secret|authorization|cookie|otp)\s*[:=]\s*[^\s,;]+/gi, '$1=[omitted]')
  .slice(0, limit);
export const reportBrowserError = (kind: string, error: unknown, componentStack = '') => {
  if (!enabled || inFlight) return;
  if (Date.now() - resetAt > 60000) { resetAt = Date.now(); sent = 0; seen.clear(); }
  const message = scrub(error instanceof Error ? error.message : 'Browser operation failed', 1000);
  const requestId = error instanceof Error ? (error as Error & { requestId?: string }).requestId : undefined;
  const correlation = typeof requestId === 'string' && /^[a-f0-9]{32}$/.test(requestId) ? requestId : undefined;
  const signature = kind + message;
  if (sent >= 5 || seen.has(signature)) return;
  seen.add(signature); sent += 1; inFlight = true;
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 3000);
  fetch(`${process.env.REACT_APP_API_URL}/log-error`, {
    method: 'POST', credentials: 'omit', signal: controller.signal,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ kind, message, requestId: correlation, release: process.env.REACT_APP_RELEASE_SHA || 'unknown', errorName: error instanceof Error ? scrub(error.name, 100) : 'Error',
      stack: error instanceof Error ? scrub(error.stack || '', 2000) : '', componentStack: scrub(componentStack, 2000) }),
  }).catch(() => { /* Reporting failures must never recursively report themselves. */ })
    .finally(() => { window.clearTimeout(timeout); inFlight = false; });
};
let installed = false;
export const installBrowserTelemetry = () => {
  if (!enabled || installed) return;
  installed = true;
  window.addEventListener('error', (event) => {
    if (event instanceof ErrorEvent) reportBrowserError('window', event.error || new Error('Browser script failed'));
    else reportBrowserError('resource', new Error('Browser resource failed'));
  }, true);
  window.addEventListener('unhandledrejection', (event) => reportBrowserError('rejection', event.reason));
};
